import React from 'react';
import { Link } from 'react-router-dom';
import aboutImg from '../assets/about.jpeg';
import serviceImg from '../assets/service.jpeg';
import whyChooseImg from '../assets/why choose us.jpg';
import careerImg from '../assets/career.jpg';
import '../styles/pages.css';

const sections = [
  {
    title: 'About Us',
    points: [
      'Integritz Technologies Private Limited is an emerging IT solutions company focused on delivering reliable, secure, and scalable technology solutions to modern enterprises.',
      'We provide end-to-end cloud solutions, networking, security, data center, storage and IT hardware helping organizations build and manage robust IT infrastructure aligned with their business goals.',
      'At Integritz, we believe in the fusion of human values and technology. Our approach combines technical expertise with integrity, transparency, and a strong commitment to long-term relationships.',
      'We work closely with our customers to understand their requirements and deliver solutions that are practical, future-ready, and cost-effective'
    ],
    link: '/about',
    btnText: 'Learn More',
    img: aboutImg,
    imgAlt: 'About Us',
    imgLeft: true,
    bg: 'white'
  },
  {
    title: 'Our Services & Solutions',
    points: [
      'At Integritz Technologies Private Limited, we deliver comprehensive IT infrastructure solutions designed to support modern businesses with reliable, secure, and scalable technology.',
      'Our services span the complete IT lifecycle—from planning and procurement to implementation and ongoing support—ensuring that our customers can focus on their core business while we manage their technology foundation.'
    ],
    link: '/services',
    btnText: 'View All Services & Solutions',
    img: serviceImg,
    imgAlt: 'Our Services',
    imgLeft: false,
    bg: 'var(--light)'
  },
  {
    title: 'Why Choose Us',
    points: [
      'At Integritz Technologies Private Limited, we believe that strong technology solutions are built on trust, expertise, and long-term commitment.',
      'As a growing IT services company, we combine agility with enterprise-focused practices to deliver meaningful value to our customers'
    ],
    link: '/why-choose-us',
    btnText: 'Learn More',
    img: whyChooseImg,
    imgAlt: 'Why Choose Us',
    imgLeft: true,
    bg: 'white'
  },
  {
    title: 'Career',
    points: [
      'At Integritz Technologies Private Limited, we are building a team that values learning, collaboration, and excellence. We offer opportunities to work on diverse IT infrastructure projects, gain hands-on experience with modern technologies, and grow alongside a dynamic and evolving organization.',
      'If you are motivated, curious, and eager to contribute to meaningful technology solutions, we invite you to explore career opportunities with us.'
    ],
    link: '/career',
    btnText: 'View Opportunities',
    img: careerImg,
    imgAlt: 'Career',
    imgLeft: false,
    bg: 'var(--light)'
  }
];

function Home() {
  return (
    <div>
      <section className="hero">
        <div className="container">
          <h1>INTEGRITZ TECHNOLOGIES PRIVATE LIMITED</h1>
          <h2>Fusion of Human Values and Technology</h2>
        </div>
      </section>

      {sections.map((sec) => (
        <section key={sec.title} className="section" style={{ background: sec.bg }}>
          <div className="container">
            <h2 className="section-title">{sec.title}</h2>
            <div className="content-grid">
              {sec.imgLeft && (
                <div>
                  <img src={sec.img} alt={sec.imgAlt} style={{ width: '100%', borderRadius: '10px' }} />
                </div>
              )}
              <div className="content-text">
                <ul className="overview-list">
                  {sec.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
                <Link to={sec.link}>
                  <button className="btn btn-primary">{sec.btnText}</button>
                </Link>
              </div>
              {!sec.imgLeft && (
                <div>
                  <img src={sec.img} alt={sec.imgAlt} style={{ width: '100%', borderRadius: '10px' }} />
                </div>
              )}
            </div>
          </div>
        </section>
      ))}
    </div>
  );
}

export default Home;
